<div class="wrapper">
  <div class="main" [class.main-cst]="isSpecialPage" [class.after-login-dv]="isLogin" [class.mini-menu-shell-page]="isMiniMenuPage" [class.tour-reading-shell]="isTourPage">
    <!-- when clicked why hungery main-cst otherwise not -->
    <!-- <app-ui-header></app-ui-header> -->
    <app-header *ngIf="!isMiniMenuPage && !isTourPage" [isLogin]="isLogin"></app-header>
    <div class="main-content" #mainContent>
      <router-outlet></router-outlet>
    </div>
    <app-footer *ngIf="footerReady && !isMiniMenuPage && !isTourPage" [isLogin]="isLogin"></app-footer>
  </div>
</div>
<app-loader *ngIf="!isMiniMenuPage && !isTourPage"></app-loader>
<app-tour-overlay></app-tour-overlay>
